import axios from "axios";
import { useState } from "react";
import ListAbsenGuru from "./ListAbsenGuru";

const AbsenGuru = () => {
  const [tahun, setTahun] = useState("");
  const [semester, setSemester] = useState("");
  const [tanggal, setTanggal] = useState("");

  const [absensiId, setAbsensiId] = useState(null);
  const [status, setStatus] = useState(false);
  const [dataExists, setDataExists] = useState(false);

  const [gurus, setGurus] = useState([]);
  const [showList, setShowList] = useState(false);
  const [absensiData, setAbsensiData] = useState({});
  const [finished, setFinished] = useState(false);

  const token = localStorage.getItem("token");

  /* ================= LOAD HEADER JIKA SUDAH ADA ================= */
  const loadExistingHeader = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/absensiguru/check`,
        {
          params: { tahun, semester, tanggal },
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (!res.data.data) return;

      setAbsensiId(res.data.data._id);
      setStatus(res.data.data.status);

      // 🔥 ambil sisa guru dari backend
      const remainingRes = await axios.get(
        `${process.env.REACT_APP_API_URL}api/absensiguru/remaining-guru`,
        {
          params: { tahun, semester, tanggal },
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const remaining = remainingRes.data;

      setGurus(remaining);

      const defaultState = {};
      remaining.forEach((user) => {
        defaultState[user._id] = {
          status: "hadir",
          keterangan: "",
        };
      });

      setAbsensiData(defaultState);

      if (remaining.length === 0) {
        setFinished(true);
        setDataExists(true);
        setShowList(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  /* ================= LOAD & CHECK ================= */
  const handleLoadGuru = async () => {
    if (!tahun || !semester || !tanggal) {
      alert("Tahun, Semester dan Tanggal wajib diisi");
      return;
    }

    try {
      const check = await axios.get(
        `${process.env.REACT_APP_API_URL}api/absensiguru/check`,
        {
          params: { tahun, semester, tanggal },
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (check.data.exists) {
        setDataExists(true);
        await loadExistingHeader();
        return;
      }

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}api/absensiguru`,
        { tahun, semester, tanggal },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      setAbsensiId(res.data.data._id);
      setStatus(res.data.data.status);
      setDataExists(false);
      setFinished(false);
      setGurus([]);
    } catch (err) {
      alert("Terjadi kesalahan");
    }
  };

  /* ================= TOGGLE STATUS ================= */
  const handleToggleStatus = async () => {
    const newStatus = !status;

    const res = await axios.patch(
      `${process.env.REACT_APP_API_URL}api/absensiguru/status/${absensiId}`,
      { status: newStatus },
      { headers: { Authorization: `Bearer ${token}` } },
    );

    setStatus(res.data.status);
  };

  /* ================= LOAD LIST GURU ================= */
  const handleShowList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/absensiguru/remaining-guru`,
        {
          params: { tahun, semester, tanggal },
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const remaining = response.data;

      setGurus(remaining);

      const defaultState = {};
      remaining.forEach((user) => {
        defaultState[user._id] = {
          status: "hadir",
          keterangan: "",
        };
      });

      setAbsensiData(defaultState);
      setShowList(true);

      // 🔥 Jika kosong berarti semua sudah diisi
      if (remaining.length === 0) {
        setFinished(true);
        setDataExists(true);
        setShowList(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ================= STATUS CHANGE ================= */
  const handleStatusChange = (id, value) => {
    setAbsensiData((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        status: value,
      },
    }));
  };

  /* ================= KETERANGAN ================= */
  const handleKeteranganChange = (id, value) => {
    setAbsensiData((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        keterangan: value,
      },
    }));
  };

  /* ================= SUBMIT ================= */
  const handleSubmitUser = async (user) => {
    if (status) {
      alert("Absensi sedang ditutup");
      return;
    }

    const data = absensiData[user._id];

    await axios.post(
      `${process.env.REACT_APP_API_URL}api/absensiguru`,
      {
        tahun,
        semester,
        tanggal,
        guruId: user._id,
        sakit: data.status === "sakit" ? 1 : 0,
        izin: data.status === "izin" ? 1 : 0,
        tanpaKeterangan: data.status === "tanpaKeterangan" ? 1 : 0,
        keterangan: data.keterangan,
      },
      { headers: { Authorization: `Bearer ${token}` } },
    );

    const updated = gurus.filter((g) => g._id !== user._id);
    setGurus(updated);

    // 🔥 jika sudah kosong
    if (updated.length === 0) {
      setShowList(false);
      setFinished(true);
      setDataExists(true);

      // 🔥 ambil ulang header untuk update status
      const header = await axios.get(
        `${process.env.REACT_APP_API_URL}api/absensiguru/check`,
        {
          params: { tahun, semester, tanggal },
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setStatus(header.data.data.status);
    }
  };
  /* ================= BUTTON STYLE ================= */
  const getButtonClass = (id, value, color) => {
    return absensiData[id]?.status === value
      ? `${color} text-white px-3 py-1 rounded ring-2 ring-black`
      : "bg-gray-200 px-3 py-1 rounded";
  };

  return (
    <div className="min-h-screen bg-blue-100 py-6">
      <div className="bg-white p-6 rounded-xl shadow-md">
        <h1 className="text-2xl font-bold text-center mb-6">
          Form Absensi Staff & Guru
        </h1>

        {/* FORM HEADER */}
        <div className="grid md:grid-cols-4 gap-4 mb-6">
          <input
            type="text"
            placeholder="Tahun"
            value={tahun}
            onChange={(e) => setTahun(e.target.value)}
            className="border p-2 rounded"
          />

          <select
            value={semester}
            onChange={(e) => setSemester(e.target.value)}
            className="border p-2 rounded"
          >
            <option value="">Pilih Semester</option>
            <option value="Ganjil">Ganjil</option>
            <option value="Genap">Genap</option>
          </select>

          <input
            type="date"
            value={tanggal}
            onChange={(e) => setTanggal(e.target.value)}
            className="border p-2 rounded"
          />

          <button
            onClick={handleLoadGuru}
            className="bg-blue-700 text-white rounded px-4 py-2"
          >
            Load Guru
          </button>
        </div>

        {dataExists && (
          <div className="text-green-600 text-center font-semibold">
            Data sudah tersedia ✅
          </div>
        )}

        {absensiId && !finished && (
          <div className="flex gap-4 mb-6">
            <button
              onClick={handleToggleStatus}
              className={`px-4 py-2 rounded text-white ${
                status ? "bg-green-600" : "bg-red-600"
              }`}
            >
              {status ? "Buka Absensi" : "Tutup Absensi"}
            </button>

            {!status && (
              <button
                onClick={handleShowList}
                className="bg-purple-600 text-white px-4 py-2 rounded"
              >
                List Staff & Guru
              </button>
            )}
          </div>
        )}

        {showList && !status && (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border text-sm">
              <thead className="bg-blue-600 text-white">
                <tr>
                  <th className="p-2 border">No</th>
                  <th className="p-2 border">Nama</th>
                  <th className="p-2 border">Hadir</th>
                  <th className="p-2 border">Sakit</th>
                  <th className="p-2 border">Izin</th>
                  <th className="p-2 border">TK</th>
                  <th className="p-2 border">Keterangan</th>
                  <th className="p-2 border">Submit</th>
                </tr>
              </thead>
              <tbody>
                {gurus.map((user, index) => (
                  <tr key={user._id} className="text-center">
                    <td className="border p-2">{index + 1}</td>
                    <td className="border p-2 font-semibold">{user.name}</td>

                    <td className="border p-2">
                      <button
                        onClick={() => handleStatusChange(user._id, "hadir")}
                        className={getButtonClass(
                          user._id,
                          "hadir",
                          "bg-green-500",
                        )}
                      >
                        ✔ Hadir
                      </button>
                    </td>

                    <td className="border p-2">
                      <button
                        onClick={() => handleStatusChange(user._id, "sakit")}
                        className={getButtonClass(
                          user._id,
                          "sakit",
                          "bg-yellow-500",
                        )}
                      >
                        ✔ Sakit
                      </button>
                    </td>

                    <td className="border p-2">
                      <button
                        onClick={() => handleStatusChange(user._id, "izin")}
                        className={getButtonClass(
                          user._id,
                          "izin",
                          "bg-blue-500",
                        )}
                      >
                        ✔ Izin
                      </button>
                    </td>

                    <td className="border p-2">
                      <button
                        onClick={() =>
                          handleStatusChange(user._id, "tanpaKeterangan")
                        }
                        className={getButtonClass(
                          user._id,
                          "tanpaKeterangan",
                          "bg-red-500",
                        )}
                      >
                        ✔ TK
                      </button>
                    </td>

                    <td className="border p-2">
                      <input
                        type="text"
                        value={absensiData[user._id]?.keterangan}
                        onChange={(e) =>
                          handleKeteranganChange(user._id, e.target.value)
                        }
                        className="border px-2 py-1 rounded w-full"
                      />
                    </td>

                    <td className="border p-2">
                      <button
                        onClick={() => handleSubmitUser(user)}
                        className="bg-purple-600 text-white px-3 py-1 rounded"
                      >
                        Submit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {finished && (
          <div className="text-green-600 text-center font-bold mt-4">
            Semua guru sudah diabsen ✅
          </div>
        )}
      </div>
      <div>
        <ListAbsenGuru />
      </div>
    </div>
  );
};

export default AbsenGuru;
